module.exports = __webpack_public_path__ + "static/media/certified_salesforce.6a38c29f.png";